import { HttpInterceptorFn } from '@angular/common/http';
import { applicationHttpErrorInterceptor } from './application-http-error/application-http-error.interceptor';
import { authRefreshInterceptor } from './auth-refresh/auth-refresh.interceptor';
import { localeInterceptor } from './locale.interceptor';
import { offlineGateInterceptor } from './offline-gate/offline-gate.interceptor';
import { stretchitApiHeadersInterceptor } from './stretchit-api-headers/stretchit-api-headers.interceptor';
import { stripeAuthInterceptor } from './stripe-auth/stripe-auth.interceptor';
import { testCountryInterceptor } from './test-country/test-country.interceptor';

export const APP_HTTP_INTERCEPTORS: readonly HttpInterceptorFn[] = [
  applicationHttpErrorInterceptor,
  offlineGateInterceptor,
  authRefreshInterceptor,
  stretchitApiHeadersInterceptor,
  stripeAuthInterceptor,
  localeInterceptor,
  // QA-заголовок X-Test-Country: строго после stretchitApiHeadersInterceptor (он заменяет все headers)
  testCountryInterceptor,
];
